import React from 'react';
import PropTypes from 'prop-types';

import '../inputs.scss';

const EntranceInput = ({ value, onChange, placeholder = 'Подъезд' }) => (
    <label htmlFor="entrance" styleName="input--has-float-label">
        <input
            styleName="input input--entrance"
            type="tel"
            id="entrance"
            name="entrance"
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            maxLength={8}
        />
        <div styleName="input__label">{placeholder}</div>
    </label>
);

export default EntranceInput;

EntranceInput.propTypes = {
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
};

